import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { pendingTasksReducer } from 'react-redux-spinner'
import app from './app'
import charges from './charges'
import login from './login'
import register from './register'

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  pendingTasks: pendingTasksReducer,
  app,
  charges,
  login,
  register
})

export default createRootReducer